exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html, body {\r\n    font-family: \"Arial\", \"Helvetica\", \"sans-serif\";\r\n    font-size: 16px;\r\n    margin: 0;\r\n    overflow: hidden;\r\n    padding: 0;\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n#vc-3d-app {\r\n    height: 100%;\r\n    position: relative;\r\n    width: 100%;\r\n    margin: auto;\r\n}\r\n\r\n#vc-3d-ui {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n}", ""]);

// exports
